export var ExternalFlowLayoutType;
(function (ExternalFlowLayoutType) {
    ExternalFlowLayoutType["FULL_MODAL"] = "full-modal";
    ExternalFlowLayoutType["FULL_WIDTH"] = "full-width";
    ExternalFlowLayoutType["PROMPT"] = "prompt";
    ExternalFlowLayoutType["SIXTY_FORTY"] = "sixty-forty";
})(ExternalFlowLayoutType || (ExternalFlowLayoutType = {}));
